import { openNotification } from "../../../Components/Notification";
import { generateSecureState } from "../../../Utils/generic-functions";
import { LEVER_HIRE_OAUTH_SCOPE, LEVER_HIRE_OAUTH_SERVER } from "../../../Utils/app-integration-constants";

const LEVER_CONFIG = {
  client_id: process.env.REACT_APP_LEVER_HIRE_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_LEVER_HIRE_OAUTH_CALLBACK_REDIRECT_URI,
};

export const useLeverHireConnect = () => {

  const handleLeverHireConnect = async (): Promise<void> => {
    if(!LEVER_CONFIG.client_id){
        console.error("Lever Client ID not configured.");
        openNotification("error", "Lever Client ID not configured.", "");
        return;
    }
    
    if(!LEVER_CONFIG.redirect_uri){
        console.error("Lever Redirect URI not configured.");
        openNotification("error", "Lever Redirect URI not configured.", "");
        return;
    }

    const params = new URLSearchParams({
        client_id: LEVER_CONFIG.client_id,
        redirect_uri: LEVER_CONFIG.redirect_uri,
        response_type: "code",
        state: generateSecureState(),
        scope: LEVER_HIRE_OAUTH_SCOPE,
      });

      const leverAuthUrl = `${LEVER_HIRE_OAUTH_SERVER.trim()}?${params.toString()}`;
      sessionStorage.setItem("lever_oauth_state", params.get("state") || "");

      window.location.href = leverAuthUrl;
  };

  return {
    handleLeverHireConnect,
  };
};
